import {useState} from 'react'
import FormErrors from '../components/FormErrors'
import {login} from '../lib/allauth'
import {useConfig} from '../auth'
import ProviderList from '../socialaccount/ProviderList'
import {Link} from "react-router-dom";

export default function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [response, setResponse] = useState({fetching: false, content: null})
    const config = useConfig()
    const hasProviders = config.data.socialaccount?.providers?.length > 0

    function submit() {
        setResponse({...response, fetching: true})
        const payload = {password};
        if (email.indexOf("@") > -1) {
            payload.email = email;
        } else {
            payload.username = email;
        }
        login(payload).then((content) => {
            setResponse((r) => {
                return {...r, content}
            })
        }).catch((e) => {
            console.error(e)
            window.alert(e)
        }).then(() => {
            setResponse((r) => {
                return {...r, fetching: false}
            })
        })
    }

    function handleKeyDown(event) {
        if (event.key === 'Enter') {
            submit();
        }
    }

    return (
        <div className={'centeredForm'}>

            <FormErrors errors={response.content?.errors}/>

            <div>
                <label>Email / Username</label>
                <div>
                    <input value={email}
                           onChange={(e) => setEmail(e.target.value)}
                           onKeyDown={handleKeyDown}
                           type='email'
                           required/>
                </div>
                <FormErrors param='email' errors={response.content?.errors}/>
                <FormErrors param='username' errors={response.content?.errors}/>
            </div>
            <div>
                <label>Password</label>
                <div>
                    <input value={password}
                           onChange={(e) => setPassword(e.target.value)}
                           onKeyDown={handleKeyDown}
                           type='password'
                           required/>
                </div>
                <FormErrors param='password' errors={response.content?.errors}/>
            </div>

            <div className={'fieldLogin'}>
                <button disabled={response.fetching} onClick={() => submit()}>Login</button>
                <Link to={'/account/password/reset'}>Forgot your password?</Link>

            </div>

            <hr/>

            {hasProviders &&
                <div className={'socialProviders'}><ProviderList callbackURL='/account/provider/callback'/></div>}
        </div>
    )
}
